export default "__VITE_PUBLIC_ASSET__5a9dd630__"